var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99797 12.6667C3.99797 13.0203 4.13844 13.3594 4.38849 13.6095C4.63854 13.8595 4.97768 14 5.3313 14H10.6646C11.0183 14 11.3574 13.8595 11.6074 13.6095C11.8575 13.3594 11.998 13.0203 11.998 12.6667V4.66667H3.99797V12.6667ZM5.3313 6H10.6646V12.6667H5.3313V6ZM10.3313 2.66667L9.66463 2H6.3313L5.66463 2.66667H3.3313V4H12.6646V2.66667H10.3313Z",
    fill: "#2F2D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete2.ca8dd7cabf28c13dd67955a552bb377c.svg";
export { ForwardRef as ReactComponent };